export default {"src":"__ASTRO_ASSET_IMAGE__CvrsHC9y__","width":152,"height":128,"format":"svg"}